import React, { useState, useEffect } from 'react';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import { Log } from 'ng2-logger';
import { ProgressCircleStudentProps } from '../../models/components/progress-circle-student';
import { enrollmentStatus } from '../../models/enums/enrollmentStatus';
import Tooltip from '../tooltip/main';

const T = Translator.create();
let _common: Common;

const _logger = Log.create('Progress-circle-student');

const ProgressCircleStudent = (props: ProgressCircleStudentProps) => {
    _common = new Common();

    const [statusCircle, setStatusCircle] = useState({
        statusText: T.t('r_activity_card_enrollment_status').replace('{0}', T.t('r_activity_report_not_started')),
        color: '#ffce56'
    })
    const [iconName, setIconName] = useState('');
    const [isDeadlineMissed, setIsDeadlineMissed] = useState(false);

    useEffect(() => {
        if (props.enrollmentStatus !== null) {
            switch (props.enrollmentStatus) {
                case enrollmentStatus.Completed:
                    handleChangeStatusCircle(T.t('r_activity_report_completed'), '#20c997')
                    setIconName('done')
                    break;
                case enrollmentStatus.Failed:
                    handleChangeStatusCircle(T.t('r_activity_report_failed'), '#ff6384')
                    setIconName('failed')
                    break;
                case enrollmentStatus.Incomplete:
                    if (isDeadlineMissed) {
                        handleChangeStatusCircle(T.t('r_activity_report_failed'), '#ff6384')
                        setIconName('failed')
                        break;
                    }
                    handleChangeStatusCircle(T.t('r_activity_report_not_completed'), '#36a2eb')
                    setIconName('continue')
                    break;
                case enrollmentStatus.NotStarted:
                    if (isDeadlineMissed) {
                        handleChangeStatusCircle(T.t('r_activity_report_failed'), '#ff6384')
                        setIconName('failed')
                        break;
                    }
                    handleChangeStatusCircle(T.t('r_activity_report_not_started'), '#ffce56')
                    setIconName('notstarted')
                    break;
            }
        }
    }, [props.enrollmentStatus])

    useEffect(() => {
        if (isDeadlineMissed && props.enrollmentStatus !== enrollmentStatus.Completed) {
            handleChangeStatusCircle(T.t('r_activity_report_failed'), '#ff6384')
            setIconName('failed')
        }
    }, [isDeadlineMissed])

    useEffect(() => {
        if (props.isTheCompletionCriterionOver) {
            handleChangeStatusCircle(T.t('r_activity_report_failed'), '#ff6384')
            setIconName('failed')
        }
    }, [props.isTheCompletionCriterionOver])

    useEffect(() => {
        if (props.deadline) {
            const originalDate = props.deadline;

            const formattedDate = new Date(originalDate);

            const formattedDateDeadline = formattedDate.toISOString().substring(0, 19);
            let nowDate = new Date();
            const formattedDateNow = nowDate.toISOString();
            let isMissed = formattedDateDeadline < formattedDateNow

            setIsDeadlineMissed(isMissed);
        }
        else {
            setIsDeadlineMissed(false);
        }
    }, [props.deadline])

    const handleChangeStatusCircle = (text: string, color: string) => {
        setStatusCircle({
            statusText: T.t('r_activity_card_enrollment_status').replace('{0}', text),
            color: color
        })
    }

    const renderProgressCircle = () => {
        return (
            <Tooltip data= {props.activityCard &&
                <ul className="tooltip-list w-100">   
                <li>{T.t('r_complete_req')}<span>{T.t('r_activity_completion_criteria_'+ (props.activityCard.completionType ? props.activityCard.completionType : '1'))}</span></li>
                <li>{statusCircle.statusText}</li>
                {props.activityCard.completionCriteria>0 && <li>{T.t('r_progress_percentage')}:<span> %{props.activityCard.completionCriteria} </span></li>}
                </ul>
                } position='top' >
                <span className="active-border" style={{ width: '32px', height: '32px', backgroundColor: statusCircle.color }}>
                    {
                        <span className="circle">
                            <img width={16} height={16} src={_common.GetDefaultIcons(iconName)} alt={iconName} />
                        </span>
                    }
                </span>
            </Tooltip>
        )
    }

    const handleHoverCircle = () => {
        return (
            <div className="side-tooltip" style={{ zIndex: 1000, paddingTop: 7 }}>
                <ul className="tooltip-list w-100" style={{ marginBottom: 7 }}>
                    {props.activityCard &&
                    ( <li>{T.t('r_complete_req')}<span>{T.t('r_activity_completion_criteria_'+ (props.activityCard.completionType ? props.activityCard.completionType : '1'))}</span></li>)
                    
                    }
                    <li>{statusCircle.statusText}</li>
                </ul>
            </div>
        )
    }

    return (
        renderProgressCircle()
    );

}

export default ProgressCircleStudent;
